/**
 * The one releases read both pages share — the folder grid and the release
 * page both need the flat list nested, and reading it through one hook with
 * one query key means going from the folders into a release paints from
 * cache.
 */
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { listReleases, type ReleaseRow } from "./api.js";
import { groupIntoFamilies, latestVersion, versionsOf, type ReleaseFamily } from "./release-families.js";

export const RELEASES_QUERY_KEY = ["reseller", "releases"] as const;

export interface ReleasesRead {
  families: ReleaseFamily[];
  latest: ReleaseRow | undefined;
  versionCount: number;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  refetch: () => Promise<unknown>;
}

export function useReleases(): ReleasesRead {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: RELEASES_QUERY_KEY,
    queryFn: listReleases,
  });

  const families = useMemo(() => groupIntoFamilies(data ?? []), [data]);
  const latest = useMemo(() => latestVersion(families), [families]);
  const versionCount = useMemo(
    () => families.reduce((n, f) => n + versionsOf(f).length, 0),
    [families],
  );

  return { families, latest, versionCount, isLoading, isError, error, refetch };
}
